import { Server, Cloud, Check } from "lucide-react";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { useLanguage } from "@/hooks/useLanguage";

const optionIcons = [Server, Cloud];

const OnPremiseDeploymentSection = () => {
  const { ref, isVisible } = useScrollAnimation();
  const { t, tObject } = useLanguage();
  const options = tObject<Array<{ title: string; subtitle: string; features: string[] }>>("onPremisePage.deployment.options");

  return (
    <section ref={ref} className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <p className="text-chathero-orange font-semibold text-sm mb-3">{t("onPremisePage.deployment.badge")}</p>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            {t("onPremisePage.deployment.title")}
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            {t("onPremisePage.deployment.intro")}
          </p>
        </div>

        <div className={`grid md:grid-cols-2 gap-8 max-w-5xl mx-auto transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {options.map((option, index) => {
            const Icon = optionIcons[index] || Server;
            return (
              <div
                key={index}
                className="bg-background border-2 border-border rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:border-chathero-mint/50 relative overflow-hidden"
              >
                <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-chathero-mint to-primary" />
                <div className="flex items-center gap-4 mb-6">
                  <div className={`w-14 h-14 rounded-2xl ${index === 0 ? "bg-chathero-mint/10" : "bg-primary/10"} flex items-center justify-center`}>
                    <Icon className={`w-7 h-7 ${index === 0 ? "text-chathero-mint" : "text-primary"}`} />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-foreground">{option.title}</h3>
                    <p className="text-sm text-muted-foreground">{option.subtitle}</p>
                  </div>
                </div>
                <ul className="space-y-3">
                  {option.features.map((feature, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <Check className="w-5 h-5 text-chathero-mint shrink-0 mt-0.5" />
                      <span className="text-muted-foreground">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default OnPremiseDeploymentSection;
